// f:/checkin/frontend/src/screens/FAQScreen/FAQSupplierScreen.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ArrowLeftIcon from '../../components/icons/ArrowLeftIcon';
import FAQAccordion from '../../components/ui/FAQAccordion'; // Corrected import path
import { useAuth } from '../../contexts/AuthContext'; // Assuming token might be needed or for consistency
import FormSpinnerOverlay from '../../components/ui/FormSpinnerOverlay';
import AlertMessage from '../../components/ui/AlertMessage';

const FAQSupplierScreen = () => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const { token } = useAuth(); // Get token, might be needed for authenticated endpoints
    const [faqs, setFaqs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFaqsForSupplier = async () => {
            setIsLoading(true);
            setError(null);
            try {
                // Using /api/faqs/role/supplier as specified
                const response = await fetch(`${API_BASE_URL}/api/faqs/role/supplier`, {
                    headers: {
                        // Include Authorization header if your API requires it for this endpoint
                        ...(token && { 'Authorization': `Bearer ${token}` }),
                        'Content-Type': 'application/json',
                    },
                });

                console.log(response)

                if (!response.ok) {
                    const errorData = await response.json().catch(() => ({ message: `Error fetching FAQs: ${response.statusText}` }));
                    throw new Error(errorData.message || `Error fetching FAQs: ${response.statusText}`);
                }
                const data = await response.json();
                // Ensure the data is an array and has the expected 'id', 'question', 'answer' structure
                // The API might return FAQs with 'id' as a number, FAQAccordion might expect string.
                // Or, the API might use different field names. Adjust mapping if necessary.
                setFaqs(data.map(faq => ({ ...faq, id: String(faq.id) }))); // Ensure id is a string for Accordion
            } catch (err) {
                setError(err.message);
                console.error("Error fetching supplier FAQs:", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchFaqsForSupplier();
    }, [API_BASE_URL, token]); // Re-fetch if token changes, in case auth is added/changed

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-5">
                <div className="d-flex align-items-center">
                    <Link to="/home" className="btn btn-back-circle me-3" title="Volver a servicios">
                        <ArrowLeftIcon />
                    </Link>
                    <h2 className="mb-0">Preguntas Frecuentes</h2>
                </div>
            </div>

            <FormSpinnerOverlay isLoading={isLoading} />

            {error && <AlertMessage type="danger" message={`Error al cargar las P+F: ${error}`} />}

            {!isLoading && !error && faqs.length === 0 && (
                <AlertMessage type="info" message="No hay preguntas frecuentes disponibles en este momento." />
            )}

            {!isLoading && !error && faqs.length > 0 && (
                <div className="row text-start mb-4">
                    <div className="col-12">
                        <div className="card card-metric border-0">
                            <div className="card-body px-md-2 px-0">
                                <div id="faq">
                                    <FAQAccordion faqs={faqs} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FAQSupplierScreen;
